<template>
  <v-container fluid>
    <!-- intro ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <CorePageIntro>
      <template slot="content">
        The purpose of this report is to compare the Sustaine&trade;
        recommendations to what actually happened at the location.
      </template>
    </CorePageIntro>

    <!-- date picker ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <h4 class="body-2 font-weight-bold text-right">
      Change Time:
      <date-picker
        :minute-step="15"
        :not-after="runDateUpper"
        v-model="runDate"
        type="datetime"
        format="YYYY-MM-DD HH:mm"
        confirm
        lang="en"
        class="text-right"
        width="175"
      ></date-picker>
      <v-btn @click="fetch()" fab dark small color="orange darken-3">
        <v-icon dark>sync</v-icon>
      </v-btn>
    </h4>

    <v-row align-start justify-center>
      <v-col xs="12">

        <!-- chart ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <PerformanceChart
          v-if="loaded"
          :intervals="rawData.intervals"
          :calculated="calculatedAt"
          :intervalLength="rawData.interval_length_seconds"
          :rampUpMinutes="60"
          :rampDownMinutes="30"
          :key="`chart-${componentKey}`"
        ></PerformanceChart>

        <!-- metrics (panel) ~*~*~*~*~*~*~*~*~*~*~* -->
        <PerformanceStatPanel
          v-if="loaded"
          :intervals="rawData.intervals"
          :key="`panel-${componentKey}`"
        ></PerformanceStatPanel>

        <!-- table ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <PerformanceTable
          v-if="loaded"
          :intervals="rawData.intervals"
          :key="`table-${componentKey}`"
        ></PerformanceTable>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FacilityService from '@/services/FacilityService'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'Performance',
  data() {
    return {
      loaded: false,
      runDate: '',
      runDateUpper: '',
      rawData: '',
      calculatedAt: '',
      stats: {
        totalRunEvents: 0,
        totalTargetOutput: 0.0,
        totalActualOutput: 0.0,
        totalTargetValue: 0.0,
        totalActualValue: 0.0
      },
      componentKey: 0
    }
  },
  computed: {
    ...mapGetters(['getFacilityId', 'getFacilityTimezone'])
  },
  watch: {
    rawData() {
      this.componentKey += 1
    }
  },
  created() {
    // set upper date range bound
    this.$root.loading = true
    this.runDateUpper = moment()
      .subtract(1, 'days')
      .hour(23)
      .minute(45)
      .second(0)
      .toDate()
    this.inputs(this.$route.params.x)
    this.fetch()
    this.$root.loading = false
  },
  beforeRouteUpdate(to, from, next) {
    this.$root.loading = true
    this.runDateUpper = moment()
      .subtract(1, 'days')
      .hour(23)
      .minute(45)
      .second(0)
      .toDate()
    this.inputs(to.params.x)
    this.fetch()
    this.$root.loading = false
    next()
  },
  // == Methods
  methods: {
    inputs() {
      // check for inputs
      this.runDate = moment()
        .subtract(1, 'days')
        .hour(23)
        .minute(45)
        .second(0)
        .toDate()

      if (this.$route.params.x != null) {
        this.runDate = moment(this.$route.params.x).toDate()
      }
    },
    fetch() {
      // this is the first in the line of work..
      this.loaded = false
      FacilityService.getPerformanceByDate(
        this.getFacilityId,
        this.$_datetimeMethod_formatTimeInIso(
          this.runDate,
          this.getFacilityTimezone
        )
      )
        .then(response => {
          this.rawData = []
          this.rawData = response.data
          this.date = this.rawData.report_date
          this.calculatedAt = moment(this.rawData.calculated_at_utc).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          this.loaded = true
        })
        .catch(error => { this.$toast.error("Error loading data; " + error.message) })
    }
  }
}
</script>
